import type { UUID } from '@cobliteam/common-types';

import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';

export class VehicleGroupsRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public deleteVehicleGroupFusca = (groupId: UUID): Promise<UUID> => {
    const requestData: IRequest = {
      endpoint: `/vehicle-groups/${groupId}`,
      method: HttpMethod.DELETE,
    };

    return this.requester
      .request(requestData)
      .then((response) => response.data);
  };
}

export default VehicleGroupsRequester;
